export default "__VITE_ASSET__DBxp8Yin__"